import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {Link} from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../styles/Homepage.css'; 
import '../styles/pages.css'; 
import Map from '../components/map/Map.jsx';
import HomepageBublesGraphs from '../components/graphs/HomepageBublesGraphs.jsx';
import UtilsLocalizedString from '../services/utilsLocalizedString.jsx';
import axios from 'axios';
import * as XLSX from 'xlsx';
import UtilsLocalizedExcelString from '../services/utilsLocalizedExcelString.jsx';



function HomePage(props) {
    const { t } = useTranslation();
      const [lang, setLang] = useState(props.lang);
    const[serverCalled, setServerCalled] = useState(false);
    const [dataFromServer, setDataFromServer] = useState("");
    const [speciesCount, setSpeciesCount] = useState("");
   const [countryList, setCountryList] = useState("");
    const [countrySpeciesList, setCountrySpeciesList] = useState("");
    const [excelLoadedSheet, setExcelLoadedSheet] = useState(false);
    const [excelDataSheet, setExcelDataSheet]= useState("");


  const handleFetchFromUrl = async () => {
    if(!excelLoadedSheet) {
    try {
      const url = "https://storage.googleapis.com/fgr-data-visualisation-assets/fgr_silvagris_assets.xlsx";
      const response = await axios.get(url, { responseType: 'arraybuffer' });

      const data = new Uint8Array(response.data);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      setExcelDataSheet(jsonData);
      setExcelLoadedSheet(true);
    } catch (error) {
    
      console.error('Error fetching or parsing Excel file:', error);
    }
  }
  };




  useEffect(() => {
    const fetchData = async () => {
      if(serverCalled === false) {
    
        try {
            fetch(`${process.env.REACT_APP_BACKEND_API}/submission/report/all/`, {
             method: "GET",
              headers: {
              "accept": "application/json",
               "Authorization": `Token ${process.env.REACT_APP_BACKEND_TOKEN}`
              },
    })
      .then((response) => response.json())
      .then((data) => {
         console.log(data);
        const mappedSpecies = [];
        const speciesForBubles = [];
        data.forEach((terr) => {
          var country = terr.territory.iso3
          terr.submission_species.forEach((spec) => {
            speciesForBubles.push(
              { country : country,
                name: spec.species.name,
                life_form: spec.species.life_form
              }
            );
        mappedSpecies.push({
          name: spec.species.name,
          life_form: spec.species.life_form
        })})});
        const uniqueSpecies = mappedSpecies.filter((o, index, arr) =>
          arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index);
       

      setCountrySpeciesList(uniqueSpecies);
      setDataFromServer(data);
      setSpeciesCount(uniqueSpecies);
      setCountryList(data.map((record) => record.territory.iso3 + UtilsLocalizedString(props.lang, record.territory) + "-" + record.submission_species.length.toString() ))
      setServerCalled(true);

      })
      .catch((error) => console.log(error));
           setServerCalled(true);
           
  
        } catch (error) {
            console.log("error", error);
        }
      }
    };
  
    fetchData();
    setLang(props.lang);

    handleFetchFromUrl();

  }, [props.lang, serverCalled, lang, excelLoadedSheet]);
    return (
      <React.Fragment>
        <div className="App" style={{marginTop: "2rem"}}>
         
       
{/* <Tableau type="homepage" /> */}
  
{/* <img key="temporary" style={{paddingTop: "1rem", width:"100%"}}src={process.env.PUBLIC_URL + `/img/providers-map.png`} alt="FAO logo" /> */}
   {/* <img key={props.lang} style={{paddingTop: "1rem", width:"100%"}}src={process.env.PUBLIC_URL + `/img/homepage_banner.png`} alt="FAO logo" /> */}
  
   <Container>
   <img key={props.lang} 
        style={{paddingTop: "1rem", width:"100%"}}
        src={process.env.PUBLIC_URL + `/img/FGR-homepage-banner.png`} alt="FGR banner" />
        
   <Row>
    <Col sm={8}  >
   {excelDataSheet !== "" &&
       <div className="contact-box">
      <p className="paragraph-body">
      <span>{UtilsLocalizedExcelString(props.lang, excelDataSheet[1])}</span>
      <em> {UtilsLocalizedExcelString(props.lang, excelDataSheet[2])} </em>
      <span>{UtilsLocalizedExcelString(props.lang, excelDataSheet[3])}</span></p>  
      </div>}
      <hr style={{maxWidth: "50px" , border:"0",height:"2px",background:"#116bac", opacity: "1",
}}></hr>
 {dataFromServer.length > 0   ?
 <Row>
   <h6 className="title-body">{t('homepage_graphs_title')}: {t('bubbles_title')}</h6>
   <HomepageBublesGraphs data={countrySpeciesList} lang={props.lang} />
    <Col sm={6}  >
<div className="wrapper">
     <Table  borderless 
      style ={{ borderSpacing: "0",borderCollapse: "collapse",
      borderStyle: "hidden", marginBottom: "0px",  
      borderBottom:"0px solid trasparent !important", 
      orderBottomWidth: "0"}} >
               <thead >
    <tr >
    <th  colSpan="2"style={{backgroundColor:"#F2F2F2" }}><h6 
    style={{marginTop: "1rem"}}>{t('table_one_title')}</h6></th></tr></thead>
      <tbody>
      <tr style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td className="col-9">
            <span className="table-grey-column-non-bold-text">{t('region_africa')}</span></td>

            <td >
            <span className="table-grey-column-non-bold-text">{dataFromServer.length > 0 ? 
            dataFromServer.filter((elem) => elem.territory.region.name === "Africa").length : "0"}</span>
            </td>
        </tr>
      <tr style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td className="col-9">
            <span className="table-grey-column-non-bold-text">{t('region_asia')}</span></td>

            <td >
            <span className="table-grey-column-non-bold-text">{dataFromServer.length > 0 ? 
            dataFromServer.filter((elem) => elem.territory.region.name ===  "Asia").length : "0"}</span>
            </td>
        </tr>
        <tr style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td className="col-9">
            <span className="table-grey-column-non-bold-text">{t('region_europe')}</span>
          </td>

            <td >
            <span className="table-grey-column-non-bold-text">{dataFromServer.length > 0 ? 
            dataFromServer.filter((elem) => elem.territory.region.name ===  "Europe").length : "0"}</span>
            </td>
        </tr>
      
        <tr style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td className="col-9">
            <span className="table-grey-column-non-bold-text">{t('region_lac')}</span></td>

            <td >
            <span className="table-grey-column-non-bold-text">{dataFromServer.length > 0 ? 
            dataFromServer.filter((elem) => elem.territory.region.name ===  "LAC").length : "0"}</span>
            </td>
        </tr>
        <tr style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td className="col-9">
            <span className="table-grey-column-non-bold-text">{t('region_neareast')}</span>
        </td>

            <td >
            <span className="table-grey-column-non-bold-text">{dataFromServer.length > 0 ? 
            dataFromServer.filter((elem) => elem.territory.region.name ===  "Near East").length : "0"}</span>
            </td>
        </tr>
        <tr style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td className="col-9">
            <span className="table-grey-column-non-bold-text">{t('region_north_america')}</span>
          </td>

            <td >
            <span className="table-grey-column-non-bold-text">{dataFromServer.length > 0 ? 
            dataFromServer.filter((elem) => elem.territory.region.name ===  "N America").length : "0"}</span>
            </td>
        </tr>
        <tr style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td className="col-9">
            <span className="table-grey-column-non-bold-text">{t('region_swpacific')}</span></td>

            <td >
            <span className="table-grey-column-non-bold-text">{dataFromServer.length > 0 ? 
            dataFromServer.filter((elem) => elem.territory.region.name ===  "SW Pacific").length : "0"}</span>
            </td>
        </tr>
       
        <tr style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td className="col-9">
            <span className="table-grey-column-non-bold-text">{t('total_title')}</span></td>

            <td >
            <span className="table-grey-column-non-bold-text">{dataFromServer.length > 0 ? dataFromServer.length : "0"}</span>
            </td>
        </tr>
      </tbody>
    </Table></div> </Col>
    <Col sm={6}  >
<div className="wrapper">
     <Table  borderless 
      style ={{ borderSpacing: "0",borderCollapse: "collapse",
      borderStyle: "hidden", marginBottom: "0px",  
      borderBottom:"0px solid trasparent !important", 
      orderBottomWidth: "0"}} >
               <thead >
    <tr >
    <th  colSpan="2"style={{backgroundColor:"#F2F2F2" }}>
      
      <h6 style={{marginTop: "1rem"}}>{t('table_two_title')}</h6></th></tr></thead>
      <tbody>
       
       
        <tr style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td className="col-9">
            <span className="table-grey-column-non-bold-text">{t('species_bamboo')}</span>
          </td>

            <td >
            <span className="table-grey-column-non-bold-text">{speciesCount.length > 0 ? 
            speciesCount.filter((elem) => elem.life_form ===  "2").length : "0"}</span> 
            </td>
        </tr>
        <tr style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td className="col-9">
            <span className="table-grey-column-non-bold-text">{t('species_rattans')}</span></td>

            <td >
             <span className="table-grey-column-non-bold-text">{speciesCount.length > 0 ? 
             speciesCount.filter((elem) => elem.life_form ===  "3").length : "0"}</span>
            </td>
        </tr>
        <tr style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td className="col-9">
            <span className="table-grey-column-non-bold-text">{t('species_treesshrubs')}</span>
          </td>

            <td >
            <span className="table-grey-column-non-bold-text">{speciesCount.length > 0 ? 
            speciesCount.filter((elem) => elem.life_form ===  "1").length : "0"}</span>
            </td>
        </tr>
        <tr style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td className="col-9">
            <span className="table-grey-column-non-bold-text">{t('species_treelikepalms')}</span></td>

            <td >
            <span className="table-grey-column-non-bold-text">{speciesCount.length > 0 ? 
            speciesCount.filter((elem) => elem.life_form ===  "4").length : "0"}</span> 
            </td>
        </tr>
        <tr style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td className="col-9">
            <span className="table-grey-column-non-bold-text">{t('species_other')}</span></td>

            <td >
             <span className="table-grey-column-non-bold-text">{speciesCount.length > 0 ? 
             speciesCount.filter((elem) => elem.life_form ===  "5").length : "0"}</span> 
            </td>
        </tr>
        <tr style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td className="col-9">
            <span className="table-grey-column-non-bold-text">{t('species_total')}</span></td>

            <td >
             <span className="table-grey-column-non-bold-text">{speciesCount.length > 0 ? speciesCount.length : "0"}</span> 
            </td>
        </tr>
      </tbody>
    </Table>
  
    </div> </Col>


   
  
    </Row> : <div></div>}






<br></br>



      </Col>

<Col  sm={4}  >
<div style={{marginTop: "3rem"}}>
<hr style={{maxWidth: "50px" , border:"0",height:"2px",background:"#116bac", opacity: "1",
}}></hr>

 <h5 className="title-body">{t('data_submission')}</h5>
<Button  style={{backgroundColor: "#116AAB",  border:"1px solid #116AAB", width: "300px" }}>
<a target="_blank" rel="noreferrer" 
href={`${process.env.REACT_APP_DATA_COLLECTION_PORTAL}`}  
style={{textDecoration: 'none', color: "white"}}>  
<span style={{marginLeft: "0.5rem", marginRight: "0.5rem", verticalAlign: "middle"}}>{t('item_login')}</span></a>
      </Button>
      <br/>
      <br/>
 <hr style={{maxWidth: "50px" , border:"0",height:"2px",background:"#116bac", opacity: "1",
}}></hr>
<h6 className="title-body">{t('related_links')}</h6>
 {excelDataSheet !== "" &&
 <div>{ (() => {
              let links = []
              for (var i = 10; i < excelDataSheet.length; i++) {
                links.push( <p key={i + "relevant_link"}><a target="_blank" rel="noreferrer" 
                  href={`${excelDataSheet[i][8]}${UtilsLocalizedExcelString(props.lang, excelDataSheet[1])}/`} 
                style={{textDecoration: 'none'}}><img 
                  style={{ verticalAlign: "text-bottom"}}
                  src={process.env.PUBLIC_URL + `/img/globe.svg`} alt="globe icon external link" /><span 
                  style={{color:"#116AAB", paddingLeft:"8px", paddingRight:"8px"}}>{UtilsLocalizedExcelString(props.lang, excelDataSheet[i])}</span> </a></p>)

              }
              return links

           })()}</div>}

{/* <p><a target="_blank" rel="noreferrer" href={UtilsLocalizedExcelString(props.lang, excelDataSheet[4])}  style={{textDecoration: 'none'}}><img style={{    verticalAlign: "text-bottom"}}src={process.env.PUBLIC_URL + `/img/globe.svg`} alt="globe icon external link" /><span style={{color:"#116AAB", paddingLeft:"8px", paddingRight:"8px"}}>{UtilsLocalizedExcelString(props.lang, excelDataSheet[4])}</span> </a></p>
<p><a target="_blank" rel="noreferrer" href={UtilsLocalizedExcelString(props.lang, excelDataSheet[4])}  style={{textDecoration: 'none'}}><img style={{    verticalAlign: "text-bottom"}}src={process.env.PUBLIC_URL + `/img/globe.svg`} alt="globe icon external link" /><span style={{color:"#116AAB", paddingLeft:"8px", paddingRight:"8px"}}>{UtilsLocalizedExcelString(props.lang, excelDataSheet[4])}</span> </a></p>
<p><a target="_blank" rel="noreferrer" href={UtilsLocalizedExcelString(props.lang, excelDataSheet[4])} style={{textDecoration: 'none'}}><img style={{    verticalAlign: "text-bottom"}}src={process.env.PUBLIC_URL + `/img/globe.svg`} alt="globe icon external link" /><span style={{color:"#116AAB", paddingLeft:"8px", paddingRight:"8px"}}>{UtilsLocalizedExcelString(props.lang, excelDataSheet[4])}</span> </a> </p>
<p><a target="_blank" rel="noreferrer" href={UtilsLocalizedExcelString(props.lang, excelDataSheet[4])}  style={{textDecoration: 'none'}}><img style={{    verticalAlign: "text-bottom"}}src={process.env.PUBLIC_URL + `/img/globe.svg`} alt="globe icon external link" /><span style={{color:"#116AAB", paddingLeft:"8px", paddingRight:"8px"}}>{UtilsLocalizedExcelString(props.lang, excelDataSheet[4])}</span> </a></p> */}
 {excelDataSheet !== "" &&
<div className='contact-box'>
  
<h6 className="title-body">{UtilsLocalizedExcelString(props.lang, excelDataSheet[4])}</h6>
<p className="paragraph-body"><a style={{textDecoration: 'none', color:"#116AAB"}} 
href={`mailto:${UtilsLocalizedExcelString(props.lang, excelDataSheet[5])}`}>
{UtilsLocalizedExcelString(props.lang, excelDataSheet[5])}
</a></p>
</div>}
<br/>
<div >
<hr style={{maxWidth: "50px" , border:"0",height:"2px",background:"#116bac", opacity: "1",
}}></hr>
 {excelDataSheet !== "" &&
 <h6 className="title-body">{String(UtilsLocalizedExcelString(props.lang, excelDataSheet[7])).charAt(0).toUpperCase() + String(UtilsLocalizedExcelString(props.lang, excelDataSheet[7])).slice(1)}</h6>}
 {excelDataSheet !== "" && <p  className="paragraph-body"><span>{UtilsLocalizedExcelString(props.lang, excelDataSheet[6]) + " "}<Link
    style={{ color:"#116AAB", textDecoration: "none"}}
    to={`/silvagris/${props.lang}/disclaimer`}
    
>
{String(UtilsLocalizedExcelString(props.lang, excelDataSheet[7])).toLowerCase()}
</Link></span>
 <span>.</span></p> }
</div>
{excelDataSheet !== "" &&
<div className='contact-box'>
<h6 className="title-body">{UtilsLocalizedExcelString(props.lang, excelDataSheet[8])}</h6>
<p className="paragraph-body">{UtilsLocalizedExcelString(props.lang, excelDataSheet[9])}</p>
</div> }</div>
 </Col>
 <h5 className="title-body">{t('homepage_map_title')}</h5>
       
       
       <Map data={countryList}/>   
 </Row>
 </Container>





 </div>
      </React.Fragment>
    );
  }

  export default HomePage;